/*
 * @Author: ç¯çç§æ(Lucas Huang)
 * @Date: 2019-05-23 10:27:07
 * @LastEditors: ç¯çç§æ(Lucas Huang)
 * @LastEditTime: 2019-08-15 14:11:43
 * @QQ: 1055818239
 * @Version: v0.0.1
 */
import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { LOOKUP_HTTP_PARAMS } from './RemoteParams';
import { LookupGridResult } from '../lookup-grid-options';

export interface ILookupHttpService {
    context?: any;
    /**
     * æ ¹æ®æå®çå¸®å©åæ°æ®IDåç¸å³åæ°è·åæ°æ®
     * @param uri å¸®å©åæ°æ®ID or Rest API
     * @param data æå¡å¨ç«¯æ¥æ¶åæ° key/value
     */
    getData(uri: string, params?: LOOKUP_HTTP_PARAMS): Observable<LookupGridResult>;
}
export const ServerSideToken = new InjectionToken<ILookupHttpService>('Lookup Grid HTTP service');
